// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dd9Qd","label":"styles_label__1sO1R"};